<template>
  <div class="sidePages">
    <BannerHeader />
    <PageHeader :owner="owner" />
    <main>
      <slot />
    </main>
    <Sponsors />
    <PageFooter />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

const PageHeader = defineAsyncComponent(() => import('@/components/sidePage/SidePageHeader'));
const BannerHeader = defineAsyncComponent(() => import('@/components/sidePage/SidePageBannerHeader'));
const Sponsors = defineAsyncComponent(() => import('@/components/sidePage/SidePageSponsors'));
const PageFooter = defineAsyncComponent(() => import('@/components/sidePage/SidePageFooter'));

export default {
  name: 'LayoutSidePage',

  components: {
    PageHeader,
    BannerHeader,
    Sponsors,
    PageFooter
  },

  props: {
    owner: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="postcss">
.sidePages{
  max-width:1600px;
  margin:auto;
}

.sidePages>header,
.sidePages>footer{
  @apply px-16;
}

.sidePages>main{
  @apply px-24;
  & > *:first-child{
    @apply mt-48;
  }
}

.sidePages .subSection{
  @apply px-8;
}

.sidePages section{
  @apply my-24;
}

.sidePages .sectionFullWidth{
  margin-left: 50%;
  transform: translateX(-50%);
  width: 100vw;
}

.sidePages{
  & h1, & h2, & h3, & h4, & h5{
    @apply mb-6;
  }
}

@media only screen and (max-width: 1400px) {
  .sidePages>main{
    @apply px-20;
  }
}

@media only screen and (max-width: 1200px) {
  .sidePages>main{
    @apply px-16;
  }
}

@media only screen and (max-width: 1050px) {
  .sidePages>main{
    @apply px-12;
  }
}

@media only screen and (max-width: 900px) {
  .sidePages{
    @apply overflow-x-hidden;
  }
  .sidePages>header,
  .sidePages>footer,
  .sidePages>main{
    @apply px-8;
  }
  .sidePages>main{
    & > *:first-child{
      @apply mt-16;
    }
  }
}

@media only screen and (max-width: 500px) {
  .sidePages>header,
  .sidePages>footer,
  .sidePages>main{
    @apply px-4;
  }
}
</style>
